import { jwtDecode } from 'jwt-decode';
import { getTenantFromToken } from 'utils/routeUtils';

export const version = '4.0.0';
export const navbarBreakPoint = 'xl'; // Vertical navbar breakpoint
export const topNavbarBreakpoint = 'lg';

let tenantId;

export const settings = {
  isFluid: true,
  isRTL: false,
  isDark: false,
  navbarPosition: 'vertical',
  showBurgerMenu: false, // controls showing vertical nav on mobile
  currency: '$',
  isNavbarVerticalCollapsed: true, // toggle vertical navbar collapse
  navbarStyle: 'card',
  tenant: '',
  cluster: '',
  pdfReportUrl: ''
};

function checkTokenAndProceed(callback) {
  const tokenFromLocalStorage = localStorage.getItem('token');
  let decodedToken;
  if (tokenFromLocalStorage) {
    const tenantId = getTenantFromToken();
    callback(tenantId);
  } else {
    setTimeout(() => checkTokenAndProceed(callback), 1000);
  }
}

checkTokenAndProceed(() => {
  // Callback function doesn't need to do anything in this case
});

export default { version, navbarBreakPoint, topNavbarBreakpoint, settings };
